import { createSelector, select } from '@ngrx/store';
import { AppState } from '..';
import { AuthState } from '../reducers/auth.reducer';
import { sortDomainsByLabel } from 'src/app/utils/domain-sort';

const isTruthyFlag = (value: unknown): boolean => {
  return value === true || value === 1 || value === '1';
};

export const selectAuthState = (state: AppState) => state.auth;

export const selectToken = createSelector(
  selectAuthState,
  (state: AuthState) => state.token
);

export const selectUser = createSelector(
  selectAuthState,
  (state: AuthState) => state.user
);

export const selectDomain = createSelector(
  selectAuthState,
  (state: AuthState) => state.domain
);

export const selectIsConnected = createSelector(
  selectAuthState,
  (state: AuthState) => state.isConnected
);

export const selectIsGuest = createSelector(
  selectAuthState,
  (state: AuthState) => !state.isConnected
);

export const selectIsLoading = createSelector(
  selectAuthState,
  (state: AuthState) => state.isLoading
);

export const selectEmail = createSelector(
  selectAuthState,
  (state: AuthState) => state.email
);

export const selectPasswordRequired = createSelector(
  selectAuthState,
  (state: AuthState) => state.passwordRequired
);

export const selectVerificationRequired = createSelector(
  selectAuthState,
  (state: AuthState) => state.verificationRequired
);

export const selectDomainConfirmationRequired = createSelector(
  selectAuthState,
  (state: AuthState) => state.domainConfirmationRequired
);

export const selectDomains = createSelector(
  selectAuthState,
  (state: AuthState) => state.domains ? sortDomainsByLabel(state.domains) : state.domains
);

export const selectRoles = createSelector(
  selectAuthState,
  (state: AuthState) => state.roles
);

export const selectIsOperator = createSelector(
  selectAuthState,
  (state: AuthState) => {
    if (state.roles.includes('operator')) {
      return true;
    }

    const user = state.user;
    const domain = state.domain;

    if (!user || !domain) {
      return false;
    }

    const domains = Array.isArray(user.domains) ? user.domains : [];
    const targetDomain = domains.find((item: any) => item?.uuid === domain.uuid);

    if (targetDomain) {
      const candidateFlags = [
        (targetDomain as any).can_use_chat,
        targetDomain?.pivot?.can_use_chat,
      ];

      if (candidateFlags.some(isTruthyFlag)) {
        return true;
      }

      return false;
    }

    return isTruthyFlag(user.can_use_chat);
  }
);
